import { isBrowser } from 'ha/helpers/isBrowser';
import { OneTrustCookieNames } from '../constants';

export const isBannerClosed = () => {
  if (!isBrowser()) {
    return undefined;
  }

  const isCookieBannerClosed = document.cookie.match(
    OneTrustCookieNames.optanonAlertBoxClosed,
  );

  return Boolean(isCookieBannerClosed);
};
